import React from 'react';
import { Card, CardBody, CardTitle, Row, Col, Badge } from 'reactstrap';
import { useAuth } from '../../contexts/AuthContext';

const TutorProviderDashboard = () => {
  const { userEmail } = useAuth();

  return (
    <div>
      {/* Welcome Card */}
      <Card className="mb-4" style={{ borderLeft: '4px solid #28a745' }}>
        <CardBody>
          <CardTitle tag="h4" className="mb-3">
            <i className="bi bi-mortarboard me-2" style={{ color: '#28a745' }}></i>
            Tutoring Provider Dashboard
          </CardTitle>
          <p className="lead mb-0">
            Welcome to your tutoring provider dashboard. Manage your tutoring services and track performance.
          </p>
          <Badge color="success" className="mt-2">{userEmail}</Badge>
        </CardBody>
      </Card>

      {/* Stats Cards */}
      <Row className="mb-4">
        <Col md="3" sm="6" className="mb-3">
          <Card className="h-100 shadow-sm">
            <CardBody className="text-center">
              <i className="bi bi-people-fill" style={{ fontSize: '2.5rem', color: '#28a745' }}></i>
              <h2 className="mt-3 mb-1">0</h2>
              <p className="text-muted mb-0">Total Tutors</p>
            </CardBody>
          </Card>
        </Col>
        <Col md="3" sm="6" className="mb-3">
          <Card className="h-100 shadow-sm">
            <CardBody className="text-center">
              <i className="bi bi-person-badge-fill" style={{ fontSize: '2.5rem', color: '#17a2b8' }}></i>
              <h2 className="mt-3 mb-1">0</h2>
              <p className="text-muted mb-0">Total Students</p>
            </CardBody>
          </Card>
        </Col>
        <Col md="3" sm="6" className="mb-3">
          <Card className="h-100 shadow-sm">
            <CardBody className="text-center">
              <i className="bi bi-calendar-check-fill" style={{ fontSize: '2.5rem', color: '#ffc107' }}></i>
              <h2 className="mt-3 mb-1">0</h2>
              <p className="text-muted mb-0">Active Sessions</p>
            </CardBody>
          </Card>
        </Col>
        <Col md="3" sm="6" className="mb-3">
          <Card className="h-100 shadow-sm">
            <CardBody className="text-center">
              <i className="bi bi-inbox-fill" style={{ fontSize: '2.5rem', color: '#dc3545' }}></i>
              <h2 className="mt-3 mb-1">0</h2>
              <p className="text-muted mb-0">Pending Requests</p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TutorProviderDashboard;